<p-dialog
  [className]="'eccc'"
  [header]="'Coming Soon'"
  [closable]="false"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '500px'}"
  [minY]="100"
  [maximizable]="false"
  [autoZIndex]="false">

  {{message}}

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <div class="float-right">
        <button id="COMING_SOON_closeBtn" type="button" class="btn btn-secondary" (click)="close()">{{'COMMON.actionsLabel.CLOSE' | translate}}</button>
      </div>
    </div>
  </ng-template>

</p-dialog>


